import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { AddToCartTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/addToCart.trackingInfo";

import { CartItemModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import * as CartItemMapper from "@/services/tracking/mappers/cartItem.mapper";
import * as productMapper from "@/services/tracking/mappers/product.mapper";
import * as ProductTileProductMapper from "@/services/tracking/mappers/productTileProduct.mapper";
import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";

export const track = (trackingInfo: AddToCartTrackingInfo) => {
    const event: TypedAnalyticsEvent<AddToCartTrackingInfo> = {
        event: EventType.AddToCart,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackCartItem = (cartItem: CartItemModel, quantity: number) => {
    const trackingInfo = CartItemMapper.toAddToCartTrackingInfo({
        item: cartItem,
        quantity
    });

    track(trackingInfo);
};

export const trackProductTileProduct = (
    product: Product<ProductFieldSet.ProductTile>,
    quantity: number
) => {
    const trackingInfo = ProductTileProductMapper.toAddToCartTrackingInfo({
        product,
        quantity
    });

    track(trackingInfo);
};

export const trackECommerceProduct = (
    product: Product<ProductFieldSet.Full>,
    quantity: number
) => {
    const trackingInfo = productMapper.toAddToCartTrackingInfo({
        product,
        quantity
    });

    track(trackingInfo);
};
